import React from 'react';
import { AfterSubmitFunc, FormTemplate } from 'ui-builder';
import { useProjectDetailsFieldsAdminService } from 'nekst-api';
import { useSetupAreaVersionContextRequired } from '../../SetupAreaVersionContext';
import { parseSetupAreaIdWithVersion, SetupAreaAndVersionDropdown } from 'features/tasks-forms';

export default function CopyDetailsFieldsForm(
  props: {
    afterSubmitFunc?: AfterSubmitFunc,
    ids: number[],
  }
) {
  const projectDetailsService = useProjectDetailsFieldsAdminService();

  const { setupArea } = useSetupAreaVersionContextRequired();

  return (
    <FormTemplate<{ setupAreaWithVersion: string, setupAreaVersion: string }>
      title="Copy Details Fields"
      submitFormFunc={async (data) => {
        const { setupAreaId, setupAreaVersion } = parseSetupAreaIdWithVersion(data.setupAreaWithVersion);
        await projectDetailsService.copyFields(setupAreaId, setupAreaVersion, props.ids);
        return data;
      }}
      afterSubmitFunc={props.afterSubmitFunc}
    >
      <SetupAreaAndVersionDropdown source="setupAreaWithVersion" label="Market" exceptIds={[setupArea.id]} />
    </FormTemplate>
  );
}
